import { type PreviewId, type PreviewLayer } from '../types';

export const previewLayerState: {
    queue: Set<PreviewId>;
    layers: Map<PreviewId, PreviewLayer>;
} = {
    queue: new Set(),
    layers: new Map(),
};

export function getLayers(): PreviewLayer[] {
    const { layers } = previewLayerState;

    return Array.from(layers.values());
}

export function getQueueToClose(): PreviewId[] {
    const { queue, layers } = previewLayerState;

    return Array.from(queue).filter((id) => !layers.get(id)?.isOpen);
}

export function removeClosedWidgets(ids: PreviewId[]) {
    const { queue, layers } = previewLayerState;

    previewLayerState.queue = new Set(
        Array.from(queue).filter((id) => {
            if (ids.includes(id)) {
                layers.delete(id);

                return false;
            }

            return true;
        })
    );
}

export function onlyOneWidgetOpen(id?: PreviewId) {
    const { layers } = previewLayerState;

    previewLayerState.layers = new Map(
        Array.from(layers.entries()).map(([key, entity]) => [
            key,
            {
                ...entity,
                isOpen: id === key,
            },
        ])
    );
}
